"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveOutReason = void 0;
var MoveOutReason;
(function (MoveOutReason) {
    MoveOutReason["VACANCY"] = "vacancy";
    MoveOutReason["DIVORCE"] = "divorce";
    MoveOutReason["EMIGRATION"] = "emigration";
    MoveOutReason["CHANGED_TERMS"] = "changed_terms";
    MoveOutReason["LIVING_IN_WITH_CUSTOMER"] = "living_in_with_customer";
    MoveOutReason["LIVING_IN_WITH_NON_CUSTOMER"] = "living_in_with_non_customer";
    MoveOutReason["NEW_ADDRESS_ALREADY_REGISTERED"] = "new_address_already_registered";
    MoveOutReason["CANCEL_IN_COOLDOWN"] = "cancel_in_cooldown";
    MoveOutReason["OVERLAP_SITUATION"] = "overlap_situation";
    MoveOutReason["CANCEL_ONE_PRODUCT"] = "cancel_one_product";
    MoveOutReason["DECEASED"] = "deceased";
    MoveOutReason["TAKEOVER_OR_COMPANY_CLOSURE"] = "takeover_or_company_closure";
    MoveOutReason["TAKEOVER_CONTRACT"] = "takeover_contract";
    MoveOutReason["HH_TO_SOHO"] = "hh_to_soho";
    MoveOutReason["HH_OR_SOHO_TO_SME"] = "hh_or_soho_to_sme";
    MoveOutReason["SME_TO_HH_OR_SOHO"] = "sme_to_hh_or_soho";
    MoveOutReason["NEW_ADDRESS_INCLUDES_ENERGY_COSTS"] = "new_address_includes_energy_costs";
    MoveOutReason["MOVEOUT_WITHOUTREASON"] = "moveout_withoutreason";
    MoveOutReason["BANKRUPTCY"] = "bankruptcy";
    MoveOutReason["RECOVERY_ACTION"] = "recovery_action";
})(MoveOutReason = exports.MoveOutReason || (exports.MoveOutReason = {}));
